<template>
  <div>
    <v-select
      v-model="selectedPlace"
      placeholder="Start typing to search"
      label="description"
      :options="places"
      :reduce="opt => opt.place_id"
      class="mb-2"
      @search="fetchPlaces"
      @input="onSelectedPlace"
    />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="setMarkerLoading"
    >
      <div id="locationMap" />
    </b-overlay>
    <b-button
      block
      class="mt-2"
      :disabled="billLoading || (!selectedLat && !selectedLng)"
      variant="primary"
      @click="regenerateBill"
    >
      Generate Bill
    </b-button>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import vSelect from 'vue-select'
import { onMounted, ref } from '@vue/composition-api'
import { debounce } from 'lodash'
import { BOverlay, BButton } from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    vSelect,
    BOverlay,
    BButton,
  },
  setup(_, ctx) {
    const tripId = ctx.root.$route.params.id
    const selectedPlace = ref(null)
    const selectedLat = ref(null)
    const selectedLng = ref(null)
    const map = ref(null)
    const setMarkerLoading = ref(false)
    const createMarker = () => {
      const marker = new google.maps.Marker({
        position: {
          lat: selectedLat.value,
          lng: selectedLng.value,
        },
      })
      marker.setMap(map.value)
      map.value.setCenter({
        lat: selectedLat.value,
        lng: selectedLng.value,
      })
    }
    function initMap() {
      const center = {
        lat: 31.963158, lng: 35.930359,
      }
      map.value = new google.maps.Map(document.getElementById('locationMap'), {
        zoom: 15,
        center,
      })
    }
    const places = ref([])
    const fetchPlaces = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await ctx.root.$store.dispatch('trips/searchPlaces', {
        text: search,
      })
      places.value = res.data.data.places
      loading(false)
    }, 1000)
    const onSelectedPlace = async () => {
      setMarkerLoading.value = true
      const res = await ctx.root.$store.dispatch('trips/getPlaceLatLong', {
        placeId: selectedPlace.value,
      })
      const { location } = res.data.data.results.at(0).geometry
      selectedLat.value = location.lat
      selectedLng.value = location.lng
      createMarker()
      setMarkerLoading.value = false
    }
    const billLoading = ref(false)
    const regenerateBill = async () => {
      billLoading.value = true

      const result = await axiosIns.post(`/trips/regenerate-bill/${tripId}`, {
        actualDropoff: {
          latitude: selectedLat.value.toString(),
          longitude: selectedLng.value.toString(),
        },
      })

      const isError = result?.data?.data?.status === 'error'
      billLoading.value = false
      if (isError) {
        errorNotification('Bill already exists')
      } else {
        ctx.emit('refetch-bill')
        ctx.root.$bvModal.hide('regenerate-bill-modal')
      }
    }
    onMounted(() => {
      initMap()
    })
    return {
      billLoading,
      regenerateBill,
      onSelectedPlace,
      fetchPlaces,
      places,
      setMarkerLoading,
      selectedPlace,
      selectedLat,
      selectedLng,
    }
  },
}
</script>

  <style scoped>

  #locationMap {
      width:100%;
      height: 400px;
  }
  </style>
